import React, { ReactElement, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Loader } from '@core/js/components/common/Loader/Loader';
import { usePortletConfig, withPortlet } from '@core/js/components/system/Portlet';

import BingoSchedulerList from './components/BingoSchedulerList';
import BingoSchedulerTitle from './components/BingoSchedulerTitle';

import fetchBingoScheduleAndLobby from './helpers/api/fetchBingoScheduleAndLobby';
import updateBingoScheduleAndLobby from './helpers/api/updateBingoScheduleAndLobby';
import useGetDataForApiCall from './hooks/api/useGetDataForApiCall';
import useVisibilityChange from './hooks/useVisibilityChange';
import { setPortletSettings } from './store/actions';
import { selectIsScheduleLoaded } from './store/selectors';
import { GAMES_UPDATE_INTERVAL_MS, PAGE_SIZE } from './constants';
import { PortletSettings } from './types';

import componentStyle from './BingoScheduler.scss';

interface Props {
    style: Record<string, string | never>;
}

// Component for fab-bingo and sun-bingo
export const BingoSchedulerBare = ({ style = {} }: Props): ReactElement => {
    const mergedStyles = { ...componentStyle, ...style };

    const dispatch = useDispatch();
    const isScheduleLoaded = useSelector(selectIsScheduleLoaded);
    const { games, bingoRegion, casinoName, lobbyName } = useGetDataForApiCall();
    const {
        numberOfColumns, numbersOfRoom, portletViewMode, lobbyName: portletLobbyName
    } = usePortletConfig() as PortletSettings;
    const columnsNumberClass = `bingo_scheduler__${numberOfColumns}_columns`;

    const apiObjectParams = {
        dispatch,
        games,
        bingoRegion,
        casinoName,
        lobbyName: portletLobbyName || lobbyName,
        pageSize: numbersOfRoom || PAGE_SIZE
    };

    useEffect(() => {
        dispatch(setPortletSettings({
            numberOfColumns,
            numbersOfRoom,
            portletViewMode
        }));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        fetchBingoScheduleAndLobby(apiObjectParams);

        const intervalId = setInterval(() => {
            updateBingoScheduleAndLobby(apiObjectParams);
        }, GAMES_UPDATE_INTERVAL_MS);

        return () => {
            clearInterval(intervalId);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [games]);

    useVisibilityChange(apiObjectParams);

    return (
        <div className={`${mergedStyles.bingo_scheduler_wrapper} ${numberOfColumns ? mergedStyles[columnsNumberClass] : ''}`}>
            <BingoSchedulerTitle />

            {isScheduleLoaded
                ? <BingoSchedulerList lobbyName={portletLobbyName || lobbyName} mergedStyles={mergedStyles} />
                : <Loader />
            }
        </div>
    );
};

// FIXME: remove any when those functions where globaly described
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const setPortlet: any = withPortlet();
export const BingoScheduler: any = setPortlet(BingoSchedulerBare);

export default BingoScheduler;
